class WistiaEvent {

	get GATE_UNLOCKED() { return 'gateUnlocked'; }

}

export default new WistiaEvent();
